/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* global google */
import Moment from "moment";
import React from "react";
import { Button, Modal } from "react-blueprint-library";
import "react-phone-number-input/style.css";
import {
  getEmploymentBreakHistoryInformation,
  getEmploymentHistoryInformation,
  insertEmploymentBreakHistoryInformation,
  insertEmploymentHistoryInformation,
  updateEmploymentBreakHistoryInformation,
  updateEmploymentHistoryInformation,
  updateEmploymentHistoryPSRneedsReview,
} from "../../../../api/makeAPIRequest";
import { getUSPSAddress } from "../../../../api/uspsAddress";
import "../../../../assets/stylesheets/StartApplication/CAS/EmploymentHistoryModal.scss";
import {
  clickFunc,
  createDateObject,
  isNullUndefinedOrEmpty,
  isValidDate,
  onlyNumeric,
  pasteCommaDelimited,
} from "../../../../common/Functions";
import "../../StartApplication.scss";
import USPSValidationModal from "../EmpHistUSPSValidationModal";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../../constants/Contract";

import StepOne from "./Steps/Step1";
import StepTwo from "./Steps/Step2";
import StepThreeEmplHistBreak from "./Steps/Step3";
import StepFourPSRConfirmation from "./Steps/Step4";
import {
  initialAddEmplHistState,
  initialAddEmplHistResetState,
} from "./constants";

import { getFilteredAddData, getEmplExpValue } from "./helpers";
import LostDataModal from "../../../SharedComponents/LostDataModal";
import { Dropdown } from "react-bootstrap";
import NavigationButtons from "../../../SharedComponents/NavigationButtons";

const EMPL_BREAK = "Employment Break";

class EmploymentHistoryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
    this.nextClick = this.nextClick.bind(this);
    this.addClick = this.addClick.bind(this);
    this.cancelClick = this.cancelClick.bind(this);
    this.backClick = this.backClick.bind(this);
    this.backClickPSR = this.backClickPSR.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.handleSalesChange = this.handleSalesChange.bind(this);
    this.handleIRBChange = this.handleIRBChange.bind(this);
    this.handleCurrentlyWorkingChange =
      this.handleCurrentlyWorkingChange.bind(this);
    this.handleContactEmployerChange =
      this.handleContactEmployerChange.bind(this);
    this.handleIndividualLifeChange =
      this.handleIndividualLifeChange.bind(this);
    this.handleIndividualAnnuityChange =
      this.handleIndividualAnnuityChange.bind(this);
    this.handleIndividualDisabilityChange =
      this.handleIndividualDisabilityChange.bind(this);
    this.handleLongTermCareChange = this.handleLongTermCareChange.bind(this);
    this.handleFullTimeRoleChange = this.handleFullTimeRoleChange.bind(this);
    this.handleTrainingChange = this.handleTrainingChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onFocusState = this.onFocusState.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.validateFields = this.validateFields.bind(this);
    this.updateCurrentTab = this.updateCurrentTab.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.getAddressComponents = this.getAddressComponents.bind(this);
    this.clearInputErrors = this.clearInputErrors.bind(this);
    this.handleUseSuggestedAddress = this.handleUseSuggestedAddress.bind(this);
    this.handleUseEnteredAddress = this.handleUseEnteredAddress.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.loadData = this.loadData.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.handleCloseBackModal = this.handleCloseBackModal.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleIndustryChange = this.handleIndustryChange.bind(this);
    this.handlePsrCheckboxChange = this.handlePsrCheckboxChange.bind(this);
    this.handleCurrentlyOnbreak = this.handleCurrentlyOnbreak.bind(this);
  }

  async componentDidMount() {
    this.loadData();
  }
  async componentDidUpdate(prevProps) {
    if (
      this.props.reviewEditData !== prevProps.reviewEditData ||
      this.props.isOpen !== prevProps.isOpen
    ) {
      this.loadData();
    }
  }

  async loadData() {
    if (this.props.reviewEditData !== "") {
      if (
        this.props.reviewEditData.display_start_date !==
          this.state.display_start_date ||
        this.props.reviewEditData.display_end_date !==
          this.state.display_end_date ||
        this.props.reviewEditData.display_company_name !==
          this.state.display_company_name ||
        this.props.reviewEditData.display_title !== this.state.display_title
      ) {
        var result;

        if (this.props.reviewEditData.companyname === null) {
          await this.setState({
            step_number: 0,
            currentTab: "Employment Break",
            show_add_button: true,
            show_next_button: false,
            is_add_disabled: false,
            is_next_disabled: false,
            review_edit: true,
            id: this.props.reviewEditData.id,
          });

          result = await getEmploymentBreakHistoryInformation(
            this.props.subId,
            this.props.reviewEditData.id
          );

          await this.setState({
            fulltime_student: result.employmentbreakid === 1 ? "Y" : "N",
            homemaker: result.employmentbreakid === 2 ? "Y" : "N",
            unemployment: result.employmentbreakid === 3 ? "Y" : "N",
            military: result.employmentbreakid === 4 ? "Y" : "N",
            travel: result.employmentbreakid === 5 ? "Y" : "N",
            other: result.employmentbreakid === 6 ? "Y" : "N",
            other_text: result.employmentbreakid === 6 ? result.other : "",
            show_other_panel: result.employmentbreakid === 6,
            step_number: 3,
            break_start_date: Moment(result.startdate).format("MM/DD/YYYY"),
            break_end_date: result.enddate ? Moment(result.enddate).format("MM/DD/YYYY") : null,
            showEmploymentExperienceTab: false,
            currently_onbreak: result.iscurrentlyonbreak ? "Y" : "N",
            break_end_date_disabled: result.enddate ? false : true,
          });
        } else {
          await this.setState({
            step_number: 0,
          });
          result = await getEmploymentHistoryInformation(
            this.props.subId,
            this.props.reviewEditData.id
          );

          var step_number;
          var currentTab;
          var show_add_button = false;
          var show_next_button = false;
          step_number = 1;
          currentTab = "Employment Experience";

          if (result.empstate === "PR") {
            await this.setState({ showUrbanization: true });
          }

          show_add_button = !result.salesposition;
          show_next_button = result.salesposition;

          let show_training_info = result.trainingsubsidy;

          let training_start_date =
            result.trainingstartdate === ""
              ? ""
              : Moment(result.trainingstartdate).format("MM/DD/YYYY");

          let training_end_date =
            result.trainingenddate === ""
              ? ""
              : Moment(result.trainingenddate).format("MM/DD/YYYY");

          if (result.totalsubsidyrecd !== null) {
            var subsidy = result.totalsubsidyrecd.toString();
            var commaSeparatedNumber = subsidy
              .split(/(?=(?:\d{3})+$)/)
              .join(",");
            await this.setState({ subsidy: commaSeparatedNumber });
          }
          var selectedState = result.empstate === null ? "" : result.empstate;

          let option = "";
          if (result.industryid !== null)
            option = this.props.industries.find(
              (element) => element.i_industryid === result.industryid
            );

          await this.setState({
            id: this.props.reviewEditData.id,
            sales: result.salesposition ? "Y" : "N",
            contact_employer: result.contactemployer ? "Y" : "N",
            may_we_contact_employer: result.contactemployer,
            irb: result.invrelatedbus ? "Y" : "N",
            individual_life: getEmplExpValue(result.solicitindlife),
            individual_annuity: getEmplExpValue(result.solicitindannuity),
            individual_disability: getEmplExpValue(result.solicitinddisability),
            individual_longterm: getEmplExpValue(result.solicitindltc),
            full_time_role: getEmplExpValue(result.fulltime),
            training: getEmplExpValue(result.trainingsubsidy),
            show_state_required: result.empcountry === "US",
            review_edit: true,
            step_number: step_number,
            currentTab: currentTab,
            is_add_disabled: false,
            is_next_disabled: false,
            show_add_button: show_add_button,
            show_next_button: show_next_button,
            show_training_info: show_training_info,
            title: result.jobtitle,
            company_name: result.companyname,
            employment_start_date: Moment(result.startdate).format(
              "MM/DD/YYYY"
            ),
            employment_end_date: Moment(result.enddate).format("MM/DD/YYYY"),
            street_address: result.empaddress1,
            address2: result.empaddress2,
            reason_for_leaving: result.reasonforleaving || "",
            city: result.empcity,
            state: selectedState,
            zip_code: result.empzip,
            country: result.empcountry,
            urbanization: result.urbanization,
            contact_phone: result.empphonenumber,
            training_start_date: training_start_date,
            training_end_date: training_end_date,
            currently_working: result.currentemployer ? "Y" : "N",
            end_date_disabled: result.currentemployer,
            employment_end_date_display: result.currentemployer
              ? ""
              : Moment(result.enddate).format("MM/DD/YYYY"),
            industry_select_options: this.props.industries,
            industry_select_desc: option === "" ? "" : option.i_industryname,
            industry_select_id:
              result.industryid === null ? "" : result.industryid,
            showEmploymentBreakTab: false,
          });
        }
      }
    } else {
      await this.setState({
        step_number: 1,
        industry_select_options: this.props.industries,
        industry_select_desc: "",
        industry_select_id: "",
        showEmploymentBreakTab: true,
        showEmploymentExperienceTab: true,
      });
    }
  }

  async handlePsrCheckboxChange(e) {
    await this.setState({
      psrCheckbox: e.target.checked,
      form_has_changed: true,
    });
    this.validateFields();
  }

  async handleTabChange(eventKey) {
    if (
      eventKey === "experience" &&
      this.state?.currentTab !== "Employment Experience"
    ) {
      await this.setState({
        currentTab: "Employment Experience",
        step_number: 1,
      });
      if (this.state.sales === "Y") {
        await this.setState({ show_next_button: true, show_add_button: false });
      }
      if (this.state.sales === "N") {
        await this.setState({ show_next_button: false, show_add_button: true });
      }
    } else if (
      eventKey === "break" &&
      this.state?.currentTab !== "Employment Break"
    ) {
      await this.setState({
        currentTab: "Employment Break",
        step_number: 3,
        show_next_button: false,
        show_add_button: true,
      });
    }
    this.validateFields();
  }

  async updateCurrentTab(event) {
    if (
      event.target.id === "break" &&
      this.state?.currentTab !== "Employment Break"
    ) {
      await this.setState({
        currentTab: "Employment Break",
        step_number: 3,
        show_next_button: false,
        show_add_button: true,
      });
      this.validateFields();
    } else if (
      event.target.id === "experience" &&
      this.state?.currentTab !== "Employment Experience"
    ) {
      await this.setState({
        currentTab: "Employment Experience",
        step_number: 1,
      });
      if (this.state.sales === "Y") {
        await this.setState({ show_next_button: true, show_add_button: false });
      }
      if (this.state.sales === "N") {
        await this.setState({ show_next_button: false, show_add_button: true });
      }
      this.validateFields();
    }
  }
  async validateFields() {
    const currDate = Moment();

    if (this.state.step_number === 1) {
      const result = this.state.contact_phone.replace(/\s/g, "");
      const hasError =
        this.state.title.trim(" ").length < 1 ||
        this.state.company_name.trim(" ").length < 1 ||
        this.state.employment_start_date.includes("_") ||
        this.state.employment_start_date === "" ||
        !isValidDate(this.state.employment_start_date) ||
        Moment(this.state.employment_start_date) > currDate ||
        (this.state.currently_working !== "Y" &&
          (this.state.employment_end_date.includes("_") ||
            isNullUndefinedOrEmpty(this.state.employment_end_date) ||
            !isValidDate(this.state.employment_end_date) ||
            Moment(this.state.employment_end_date) > currDate ||
            Moment(this.state.employment_end_date) <
              Moment(this.state.employment_start_date))) ||
        (this.state.country === "US" &&
          this.state.state.trim(" ").length === 0) ||
        this.state.street_address.trim(" ").length < 1 ||
        this.state.city.trim(" ").length < 1 ||
        this.state.reason_for_leaving.trim(" ").length === 1 ||
        this.state.zip_code.trim(" ").length < 5 ||
        this.state.country.trim(" ").length <= 0 ||
        this.state.sales.trim(" ").length <= 0 ||
        this.state.irb.trim(" ").length <= 0 ||
        this.state.currently_working.trim(" ").length <= 0 ||
        this.state.contact_employer.trim(" ").length <= 0 ||
        this.state.title_error ||
        this.state.company_name_error ||
        this.state.employment_start_date_error ||
        this.state.employment_end_date_error ||
        this.state.street_address_error ||
        this.state.city_error ||
        this.state.zip_code_error ||
        this.state.country_error ||
        this.state.state_error ||
        this.state.contact_phone_error ||
        this.state.industry_select_id === "" ||
        (this.state.contact_employer === "Y" &&
          (this.state.contact_phone.includes("_") || result.length < 11));

      await this.setState({
        is_add_disabled: hasError,
        is_next_disabled: hasError,
      });
    } else if (this.state.step_number === 2) {
      const hasError =
        this.state.training === "N"
          ? this.state.individual_life.trim(" ").length === 0 ||
            this.state.individual_annuity.trim(" ").length === 0 ||
            this.state.individual_disability.trim(" ").length === 0 ||
            this.state.individual_longterm.trim(" ").length === 0 ||
            this.state.full_time_role.trim(" ").length === 0 ||
            this.state.training.trim(" ").length === 0
          : this.state.training === "Y"
            ? this.state.individual_life.trim(" ").length === 0 ||
              this.state.individual_annuity.trim(" ").length === 0 ||
              this.state.individual_disability.trim(" ").length === 0 ||
              this.state.individual_longterm.trim(" ").length === 0 ||
              this.state.full_time_role.trim(" ").length === 0 ||
              this.state.training.trim(" ").length === 0 ||
              this.state.training_start_date.includes("_") ||
              this.state.training_start_date === "" ||
              !isValidDate(this.state.training_start_date) ||
              Moment(this.state.training_start_date) > currDate ||
              this.state.training_end_date.includes("_") ||
              this.state.training_end_date === "" ||
              !isValidDate(this.state.training_end_date) ||
              Moment(this.state.training_end_date) > currDate ||
              Moment(this.state.training_end_date) <
                Moment(this.state.training_start_date) ||
              Moment(this.state.training_start_date) <
                Moment(this.state.employment_start_date) ||
              Moment(this.state.training_start_date) >
                Moment(this.state.employment_end_date) ||
              Moment(this.state.training_end_date) <
                Moment(this.state.employment_start_date) ||
              Moment(this.state.training_end_date) >
                Moment(this.state.employment_end_date) ||
              (!this.props.hasNYRegs && this.state.subsidy.length === 0) ||
              this.state.training_start_date_error ||
              this.state.training_end_date_error
            : true;
      await this.setState({
        employment_end_date:
          this.state.employment_end_date === "Invalid date"
            ? Moment().format("MM/DD/YYYY")
            : this.state.employment_end_date,
        is_add_disabled: hasError,
      });
    } else if (this.state.step_number === 3) {
      const isBreakStartDateValid =
        !this.state.break_start_date.includes("_") &&
        this.state.break_start_date !== "" &&
        isValidDate(this.state.break_start_date) &&
        Moment(this.state.break_start_date) <= currDate 

      const isBreakEndDateValid = this.state.break_end_date &&
        !this.state.break_end_date.includes("_") &&
        this.state.break_end_date !== "" &&
        isValidDate(this.state.break_end_date) &&
        Moment(this.state.break_end_date) <= currDate &&
        Moment(this.state.break_end_date) >=
          Moment(this.state.break_start_date) &&
        !this.state?.break_start_date_error &&
        !this.state?.break_end_date_error;

      let validOther =
        this.state.other === "Y" &&
        this.state.other_text.trim(" ").length > 1 &&
        (this.state.break_end_date_disabled && isBreakStartDateValid ? true : isBreakEndDateValid)

      let validNonOther =
        this.state.other === "N" &&
        (this.state.fulltime_student === "Y" ||
          this.state.homemaker === "Y" ||
          this.state.unemployment === "Y" ||
          this.state.military === "Y" ||
          this.state.travel === "Y") &&
          (this.state.currently_onbreak === "Y" || this.state.currently_onbreak === "N") &&
          (this.state.break_end_date_disabled && isBreakStartDateValid ? true : isBreakEndDateValid);

      let validOnBreak= this.state.currently_onbreak === "Y" || this.state.currently_onbreak === "N"

      await this.setState({ is_add_disabled: !(validOnBreak && (validOther || validNonOther)) });
    } else if (this.state.step_number === 4) {
      await this.setState({ is_add_disabled: !this.state.psrCheckbox });
    }
  }
  async onFocusState() {
    await this.setState({ ctrl_with_focus: "" });

    var inputs = document.querySelectorAll("button, a");
    try {
      for (var i = 0; i < inputs.length; ++i) {
        inputs[i].addEventListener("focusout", (event) => {
          if (event.relatedTarget == null) {
            this.setState({ ctrl_with_focus: "" });
          } else {
            this.setState({ ctrl_with_focus: event.relatedTarget.id });
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  async onKeyDown() {
    await this.setState({ form_has_changed: true, psrCheckbox: false });
  }

  initialState() {
    return {
      ...initialAddEmplHistState,
    };
  }

  async handleNext(x) {
    await this.setState({ showSaveLoader: true });
    if (
      (this.props.busAddrCheck === false ||
        this.props.busAddrCheck === undefined) &&
      this.state.is_validated === false && this.state.step_number !== 3
    ) {
      var CheckUSPS = false;

      let verify = false;
      if (this.state.country === "US" && this.state.state.length > 0) {
        verify = true;
      }
      if (this.state.country.length > 0) {
        verify = true;
      }
      if (
        this.state.street_address.length > 0 &&
        this.state.city.length > 0 &&
        verify &&
        //this.state.state.length > 0 &&
        this.state.zip_code.length > 0
      ) {
        CheckUSPS = true;
      }
      if (CheckUSPS === true) {
        let street = this.state.street_address;

        if (this.state.address2 !== undefined) {
          const street2 = street + ", " + this.state.address2;
          street = street2;
        } else {
          await this.setState({ address2: "" });
        }

        let data = {
          street: street,
          city: this.state.city,
          state: this.state.state,
          zip: this.state.zip_code,
          country: this.state.country,
          resurbanization: this.state.urbanization,
        };
        const response = await getUSPSAddress(data);
        let verifyLevel = "default";
        if (response.data !== "undefined") {
          verifyLevel = response.data.VerificationFlags.VerifyLevel;
        }
        if (this.state.is_validated === true) {
          this.handleCloseModal(x);
        } else {
          if (verifyLevel.includes("Verified")) {
            await this.setState({
              usps_address: response.data.Address.Street1,
              usps_address2: response.data.Address.Street2,
              usps_city: response.data.Address.City,
              usps_state: response.data.Address.State,
              usps_zip_code: response.data.Address.Zip,
              usps_country: "US",
              showModal: true,
              addressNotFound: false,
            });
          } else {
            this.handleCloseModal(x);

            await this.setState({
              usps_address: "USPS does not recognize the address you entered.",
              usps_address2: "",
              usps_city: "",
              usps_state: "",
              usps_zip_code: "",
              showModal: true,
              addressNotFound: true,
            });
          }
        }
      } else {
        let isValid = true;
        await this.setState({
          street_address_error: this.state.street_address.length === 0,
          city_error: this.state.city.length === 0,
          state_error: this.state.state.length === 0,
          zip_code_error: this.state.zip_code.length === 0,
        });

        if (
          this.state.street_address.length === 0 ||
          this.state.city.length === 0 ||
          this.state.state.length === 0 ||
          this.state.zip_code.length === 0
        ) {
          isValid = false;
        }
        isValid && this.state.sales === "Y"
          ? this.nextClick()
          : this.addClick();
      }
    } else {
      if (this.state.step_number === 1) {
        if (this.props.contracttype === CONTRACT_TYPE_DESCRIPTIONS.MMLIS) {
          if (this.state.sales === "Y") {
            // Go to step 2
            this.nextClick();
          } else {
            // Not sales pos., save directly after step 1
            this.addClick();
            await this.setState({ showSaveLoader: false });

            return;
          }
        } else {
          if (this.state.sales === "Y") {
            this.nextClick();
          } else {
            await this.setState({
              step_number: 4,
              show_next_button: false,
              show_add_button: true,
            });
          }
        }
      } else if (
        this.state.step_number === 2 &&
        this.state.review_edit === true
      ) {
        // If contracttype is MMLIS, save directly after step 2
        if (this.props.contracttype === CONTRACT_TYPE_DESCRIPTIONS.MMLIS) {
          this.addClick();
          await this.setState({ showSaveLoader: false });

          return;
        } else {
          await this.setState({
            step_number: 4,
            show_add_button: true,
            show_next_button: false,
          });

          if (!this.state.psrCheckbox) {
            await this.setState({ is_add_disabled: true });
          }
        }
      } else {
        this.addClick();
      }
    }

    await this.setState({ showSaveLoader: false });
  }

  async nextClick() {
    await this.setState({
      step_number: 2,
      show_add_button: true,
      show_next_button: false,
      is_add_disabled: !this.state.review_edit,
      is_next_disabled: true,
      showModal: false,
      disableEmploymentBreak: true,
    });

    let myRef = document.getElementById("top_element");
    myRef.scrollIntoView();
    this.validateFields();

    if (
      this.state.training_start_date !== "" &&
      this.state.training_start_date !== "Invalid date"
    ) {
      var startdateEvent = new Event("blur");
      Object.defineProperty(startdateEvent, "target", {
        writable: false,
        value: document.getElementById("training_start_date"),
      });
      await this.onBlur(startdateEvent);
    }

    if (
      this.state.training_end_date !== "" &&
      this.state.training_end_date !== "Invalid date"
    ) {
      var enddateEvent = new Event("blur");
      Object.defineProperty(enddateEvent, "target", {
        writable: false,
        value: document.getElementById("training_end_date"),
      });
      await this.onBlur(enddateEvent);
    }

    if (this.state.subsidy !== "") {
      var subsidyEvent = new Event("blur");
      Object.defineProperty(subsidyEvent, "target", {
        writable: false,
        value: document.getElementById("subsidy"),
      });
      await this.onBlur(subsidyEvent);
    }
  }
  async addClick() {
    await this.setState({ is_add_disabled: true });
    let result;

    if (
      this.state.step_number === 4 ||
      this.state.step_number === 2 ||
      this.state.step_number === 1
    ) {
      if (this.state.currently_working === "Y") {
        await this.setState({ employment_end_date: "" });
      }

      if (
        this.state.step_number === 4 ||
        this.state.step_number === 1 ||
        this.state.step_number === 2
      ) {
        if (this.state.review_edit === false) {
          const data = await getFilteredAddData(this.state);
          result = await insertEmploymentHistoryInformation(
            this.props.subId,
            data
          );
        } else {
          const data = await getFilteredAddData(this.state);
          if (this.state.sales === "N") {
            await this.setState({
              individual_life: "",
              individual_annuity: "",
              individual_disability: "",
              individual_longterm: "",
              full_time_role: "",
              training: "",
              training_start_date: "",
              training_end_date: "",
              subsidy: "",
            });
          }

          await updateEmploymentHistoryPSRneedsReview(
            this.props.subId,
            this.state.id,
            this.state.psrCheckbox
          );

          result = await updateEmploymentHistoryInformation(
            this.props.subId,
            this.state.id,
            data
          );
        }

        const data = await getFilteredAddData(this.state);

        await this.setState({ review_edit: false, step_number: 0 });
        this.props.showAlert();
        this.props.actionCancel({
          candidateid: result.data.payload[0].candidateid,
          companyname: data.companyname,
          description: null,
          enddate: data.enddate === "" ? null : data.enddate,
          id: result.data.payload[0].employmenthistoryid,
          istheregap: data.istheregap,
          jobtitle: data.jobtitle,
          overlappingRange: null,
          startdate: data.startdate,
        });
      }
    } else if (this.state.step_number === 3) {
      //save employment break record
      let employmentbreakid = 0;
      let other_text = "";
      let jobtitle = "";
      if (this.state.fulltime_student === "Y") {
        employmentbreakid = 1;
        jobtitle = "Full Time Student";
      }
      if (this.state.homemaker === "Y") {
        employmentbreakid = 2;
        jobtitle = "Homemaker";
      }
      if (this.state.unemployment === "Y") {
        employmentbreakid = 3;
        jobtitle = "Unemployment";
      }
      if (this.state.military === "Y") {
        employmentbreakid = 4;
        jobtitle = "Military Service";
      }
      if (this.state.travel === "Y") {
        employmentbreakid = 5;
        jobtitle = "Extended Travel";
      }
      if (this.state.other === "Y") {
        employmentbreakid = 6;
        other_text = this.state.other_text;
        jobtitle = this.state.other_text;
      }

      let data = {
        employmentbreakid: employmentbreakid,
        other: other_text,
        startdate: createDateObject(this.state.break_start_date),
        enddate: createDateObject(this.state.break_end_date),
        iscurrentlyonbreak: this.state.currently_onbreak,
        iscurrentlyonbreak: this.state.currently_onbreak === 'Y'? true : false ,
      };

      if (this.state.review_edit === false) {
        result = await insertEmploymentBreakHistoryInformation(
          this.props.subId,
          data
        );
      } else {
        //update record
        result = await updateEmploymentBreakHistoryInformation(
          this.props.subId,
          this.state.id,
          data
        );
      }

      await this.setState({ review_edit: false, step_number: 0 });
      this.props.showAlert();
      this.props.actionCancel({
        candidateid: result.data.payload[0].candidateid,
        companyname: null,
        description: null,
        enddate: data.enddate === "" ? null : data.enddate,
        id: result.data.payload[0].employmentbreakhistoryid,
        istheregap: data.istheregap,
        jobtitle: jobtitle,
        overlappingRange: null,
        startdate: data.startdate,
      });
    }

    await this.resetFields();
  }

  async cancelClick() {
    this.props.actionCancel(null);
    this.resetFields();
  }

  async backClick() {
    await this.setState({
      step_number: 1,
      is_next_disabled: false,
      show_next_button: true,
      show_add_button: false,
      disableEmploymentBreak: false,
    });
    let myRef = document.getElementById("top_element");
    myRef.scrollIntoView();
  }

  async backClickPSR() {
    const isSales = this.state.sales === "Y";

    await this.setState({
      step_number: isSales ? 2 : 1,
      is_next_disabled: false,
      show_next_button: !isSales ? true : false,
      show_add_button: !isSales ? false : true,
      is_add_disabled: false,
    });

    let myRef = document.getElementById("top_element");
    myRef.scrollIntoView();
  }

  async handleChange({ target: { id, value } }) {
    if (
      id === "fulltime_student" ||
      id === "homemaker" ||
      id === "unemployment" ||
      id === "military" ||
      id === "travel" ||
      id === "other"
    ) {
      await this.setState({
        fulltime_student: "N",
        homemaker: "N",
        unemployment: "N",
        military: "N",
        travel: "N",
        other: "N",
        other_text: "",
        other_text_error: false,
        show_other_panel: id === "other" && value === "Y",
        [id]: value,
      });

      await this.validateFields();
    } else {
      await this.setState({
        [id]: value,
      });

      if (id === "subsidy") {
        var temp = value.replaceAll(",", "");
        var truncated = temp.substring(0, 9);
        var tempNumber = truncated.replace(/,/gi, "");
        var commaSeparatedNumber = tempNumber
          .split(/(?=(?:\d{3})+$)/)
          .join(",");
        await this.setState({ subsidy: commaSeparatedNumber });
      }

      if (id === "employment_end_date_display") {
        await this.setState({
          employment_end_date_display: value,
          employment_end_date: value,
        });
        if (this.state.currently_working === "Y") {
          await this.setState({
            employment_end_date: Moment().format("MM/DD/YYYY"),
          });
        }
      }

      if (
        id === "street_address" ||
        id === "address2" ||
        id === "city" ||
        id === "state" ||
        id === "zip_code" ||
        id === "country"
      ) {
        await this.setState({ is_validated: false });
      }
      if (this.state.state === "PR") {
        await this.setState({ showUrbanization: true });
      } else {
        await this.setState({ showUrbanization: false, urbanization: "" });
      }

      await this.setState({ form_has_changed: true, psrCheckbox: false });
    }
  }
  async handlePhoneChange() {
    var phone = document.getElementById("contact_phone");
    await this.setState({
      contact_phone: phone.value,
      is_form_saved: false,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }

  async resetFields() {
    await this.setState({ ...initialAddEmplHistResetState });
  }

  async handleSalesChange(event) {
    await this.setState({
      individual_life: "",
      individual_annuity: "",
      individual_disability: "",
      individual_longterm: "",
      full_time_role: "",
      training: "",
      training_start_date: "",
      training_end_date: "",
      subsidy: "",
      sales: event.target.value,
      form_has_changed: true,
      psrCheckbox: false,
      show_next_button: event.target.value === "Y",
      show_add_button: event.target.value === "N",
    });

    this.validateFields();
  }

  async handleIRBChange(event) {
    await this.setState({
      irb: event.target.value,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }

  async handleCurrentlyWorkingChange(event) {
    event.target.value === "Y"
      ? await this.setState({
          currently_working: event.target.value,
          end_date_disabled: true,
          employment_end_date: Moment().format("MM/DD/YYYY"),
          employment_end_date_display: "",
          reason_for_leaving: "",
          employment_end_date_error: false,
          form_has_changed: true,
        })
      : await this.setState({
          currently_working: event.target.value,
          employment_end_date: "",
          end_date_disabled: false,
          form_has_changed: true,
        });
    this.validateFields();
  }

  async handleCurrentlyOnbreak(event) {
     event.target.value === "Y"
      ? await this.setState({
          currently_onbreak: event.target.value,
          break_end_date_disabled: true,
          break_end_date: "",
          break_end_date_error: false,
          form_has_changed: true,
        })
      : await this.setState({
          currently_onbreak: event.target.value,
          break_end_date: this.state.break_end_date !== "Invalid date" ? this.state.break_end_date : "",
          break_end_date_disabled: false,
          form_has_changed: true,
        });
    this.validateFields();
  }

  async handleContactEmployerChange(event) {
    await this.setState({
      contact_employer: event.target.value,
      may_we_contact_employer: event.target.value === "Y",
      contact_phone: "",
      contact_phone_error: false,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }
  async handleIndividualLifeChange(event) {
    await this.setState({
      individual_life: event.target.value,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }
  async handleIndividualAnnuityChange(event) {
    await this.setState({
      individual_annuity: event.target.value,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }
  async handleIndividualDisabilityChange(event) {
    await this.setState({
      individual_disability: event.target.value,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }
  async handleLongTermCareChange(event) {
    await this.setState({
      individual_longterm: event.target.value,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }
  async handleFullTimeRoleChange(event) {
    await this.setState({
      full_time_role: event.target.value,
      form_has_changed: true,
      psrCheckbox: false,
    });
    this.validateFields();
  }
  async handleTrainingChange(event) {
    if (event.target.value === "Y") {
      await this.setState({
        show_training_info: true,
        training: event.target.value,
        form_has_changed: true,
        psrCheckbox: false,
      });
    }
    if (event.target.value === "N") {
      await this.setState({
        show_training_info: false,
        training_start_date: "",
        training_start_date_error: false,
        training_start_date_error_text: "",
        training_end_date: "",
        training_end_date_error: false,
        training_end_date_error_text: "",
        subsidy: "",
        subsidy_error: false,
        training: event.target.value,
        form_has_changed: true,
        psrCheckbox: false,
      });
    }
    this.validateFields();
  }

  onCurrentlyWorkingYesClick = (e) => {
    e.stopPropagation();

    let obj_error = document.getElementById("end_date_error_test");
    obj_error.innerText = "";
  };

  async onBlur(event) {
    var obj_error;
    let errorText = "";
    let hasError = false;
    const currDate = Moment();
    const newDate = Moment().subtract(1, "days");
    const tenYearsAgo = Moment(newDate).subtract(10, "years");
    const eventBlur = new Event("blur");

    if (
      this.state.ctrl_with_focus.includes("option") &&
      this.state.ctrl_with_focus !== event.target.id
    ) {
      //do nothing
    } else if (event.target.id === "title") {
      await this.setState({
        formHasError: event.target.value.trim(" ").length < 2,
        title_error: event.target.value.trim(" ").length < 2,
      });
    } else if (event.target.id === "company_name") {
      await this.setState({
        formHasError: event.target.value.trim(" ").length < 2,
        company_name_error: event.target.value.trim(" ").length < 2,
      });
    } else if (event.target.id.startsWith("employment_start_date")) {
      let endDate = this.state.employment_end_date;
      if (
        event.target.value?.includes("_") ||
        event.target.value?.trim(" ").length === 0 ||
        event.target.value?.slice(-4) === "0000" ||
        !isValidDate(event.target.value)
      ) {
        errorText = "Please enter a Start Date";
        hasError = true;
      } else {
        const [month, day, year] = event.target.value?.split("/") || [];
        const dateCalc = Moment(year + "-" + month + "-" + day);
        const yearDiff = currDate.diff(dateCalc, "year");

        if (dateCalc > currDate) {
          errorText = "Start date cannot be a future date";
          hasError = true;
        } else if (yearDiff >= 100) {
          errorText = "Start date cannot be more than 100 years ago";
          hasError = true;
        } else if (
          this.state.currently_working !== "Y" &&
          isValidDate(endDate) &&
          endDate.trim(" ").length > 0
        ) {
          if (Moment(event.target.value) > Moment(endDate)) {
            errorText = "Start date cannot be after end date.";
            hasError = true;
          }
        }
      }
      await this.setState({
        employment_start_date_error: hasError,
        employment_start_date_error_text: errorText,
        formHasError: hasError,
      });

      if (
        this.state?.end_date_error &&
        !event.target.value?.includes("_") &&
        event.target.value?.trim(" ").length > 0 &&
        event.target.value?.slice(-4) !== "0000" &&
        isValidDate(event.target.value)
      ) {
        Object.defineProperty(eventBlur, "target", {
          writable: false,
          value: document.getElementById("employment_end_date"),
        });
        await this.onBlur(eventBlur);
      }
    } else if (event.target.id.startsWith("employment_end_date")) {
      const startDate = this.state?.employment_start_date;
      const endDate = Moment(event.target.value);

      if (
        event.target.value.includes("_") ||
        event.target.value.trim(" ").length === 0 ||
        event.target.value.slice(-4) === "0000" ||
        !isValidDate(event.target.value)
      ) {
        errorText = "Please enter an End Date";
        hasError = true;
      } else if (endDate < tenYearsAgo) {
        errorText = "End date must fall within the last 10 years";
        hasError = true;
      } else {
        const [month, day, year] = event.target.value?.split("/") || [];
        const dateCalc = Moment(year + "-" + month + "-" + day);
        const yearDiff = currDate.diff(dateCalc, "year");

        if (dateCalc > currDate) {
          errorText = "End date cannot be a future date";
          hasError = true;
        } else if (yearDiff >= 100) {
          errorText = "End date cannot be more than 100 years ago";
          hasError = true;
        } else if (isValidDate(startDate) && startDate.trim(" ").length > 0) {
          if (Moment(startDate) > Moment(event.target.value)) {
            errorText = "End date cannot be before Start date";
            hasError = true;
          }
        }
      }
      await this.setState({
        employment_end_date_error: hasError,
        employment_end_date_error_text: errorText,
        formHasError: hasError,
      });
      if (
        this.state?.employment_start_date_error &&
        !event.target.value?.includes("_") &&
        event.target.value?.trim(" ").length > 0 &&
        event.target.value?.slice(-4) !== "0000" &&
        isValidDate(event.target.value)
      ) {
        Object.defineProperty(eventBlur, "target", {
          writable: false,
          value: document.getElementById("employment_start_date"),
        });
        await this.onBlur(eventBlur);
      }
    } else if (event.target.id === "street_address") {
      await this.setState({
        formHasError: event.target.value.trim(" ").length < 2,
        street_address_error: event.target.value.trim(" ").length < 2,
      });
    } else if (event.target.id === "city") {
      await this.setState({
        formHasError: event.target.value.trim(" ").length < 2,
        city_error: event.target.value.trim(" ").length < 2,
      });
    } else if (event.target.id === "reason_for_leaving") {
      await this.setState({
        formHasError: event.target.value.trim(" ").length === 1,
        reason_for_leaving_error: event.target.value.trim(" ").length === 1,
      });
    } else if (
      event.target.id === "state" &&
      !event.target.id.includes("option") &&
      !this.state.ctrl_with_focus.includes("state_option")
    ) {
      await this.setState({
        state_error:
          (event.target.id === "state" &&
            event.target.innerText.trim(" ").length === 0 &&
            this.state.country === "US") ||
          (this.state.state === "" && this.state.country === "US"),
      });
    } else if (
      event.target.id === "country" &&
      !event.target.id.includes("option") &&
      this.state.ctrl_with_focus !== "country_option"
    ) {
      await this.setState({
        country_error:
          (event.target.id === "country" &&
            event.target.innerText.trim(" ").length === 0) ||
          this.state.country === "",
        show_state_required: this.state.country === "US",
        state: this.state.state === "US" ? "" : this.state.state,
      });
    } else if (event.target.id === "zip_code") {
      await this.setState({
        zip_code_error: event.target.value.trim(" ").length < 5,
        formHasError: event.target.value.trim(" ").length < 5,
      });
    } else if (event.target.id === "contact_phone") {
      const result = event.target.value.replace(/\s/g, "");
      await this.setState({
        contact_phone_error: result.length < 11,
        formHasError: result.length < 11,
      });
    } else if (event.target.id.startsWith("training_start_date")) {
      let endDate = this.state.training_end_date;
      let empStartDate = Moment(this.state.employment_start_date);
      let empEndDate = Moment(this.state.employment_end_date);

      if (
        event.target.value?.includes("_") ||
        event.target.value?.trim(" ").length === 0 ||
        event.target.value?.slice(-4) === "0000" ||
        !isValidDate(event.target.value)
      ) {
        errorText = "Please enter a Start Date";
        hasError = true;
      } else {
        const [month, day, year] = event.target.value?.split("/") || [];
        const dateCalc = Moment(year + "-" + month + "-" + day);
        const yearDiff = currDate.diff(dateCalc, "year");

        if (dateCalc > currDate) {
          errorText = "Start date cannot be a future date";
          hasError = true;
        } else if (dateCalc < empStartDate) {
          errorText = "Start date cannot be before Employment Start date.";
          hasError = true;
        } else if (dateCalc > empEndDate) {
          errorText = "Start date cannot be after Employment End date.";
          hasError = true;
        } else if (yearDiff >= 100) {
          errorText = "Start date cannot be more than 100 years ago";
          hasError = true;
        } else if (isValidDate(endDate) && endDate.trim(" ").length > 0) {
          if (Moment(event.target.value) > Moment(endDate)) {
            errorText = "Start date cannot be after End date.";
            hasError = true;
          }
        }
      }
      await this.setState({
        training_start_date_error: hasError,
        training_start_date_error_text: errorText,
        formHasError: hasError,
      });

      if (this.state?.training_end_date_error && !hasError) {
        const syntheticEvent = {
          target: {
            id: "training_end_date",
            value: this.state.training_end_date,
          },
        };
        await this.onBlur(syntheticEvent);
      }
    } else if (event.target.id.startsWith("training_end_date")) {
      const startDate = this.state?.training_start_date;
      const endDate = Moment(event.target.value);
      let empStartDate = Moment(this.state.employment_start_date);
      let empEndDate = Moment(this.state.employment_end_date);

      if (
        event.target.value.includes("_") ||
        event.target.value.trim(" ").length === 0 ||
        event.target.value.slice(-4) === "0000" ||
        !isValidDate(event.target.value)
      ) {
        errorText = "Please enter an End Date";
        hasError = true;
      } else if (endDate < tenYearsAgo) {
        errorText = "End date must fall within the last 10 years";
        hasError = true;
      } else {
        const [month, day, year] = event.target.value?.split("/") || [];
        const dateCalc = Moment(year + "-" + month + "-" + day);
        const yearDiff = currDate.diff(dateCalc, "year");

        if (dateCalc > currDate) {
          errorText = "End date cannot be a future date";
          hasError = true;
        } else if (dateCalc > empEndDate) {
          errorText = "End date cannot be after Employment End date.";
          hasError = true;
        } else if (dateCalc < empStartDate) {
          errorText = "End date cannot be before Employment Start date.";
          hasError = true;
        } else if (yearDiff >= 100) {
          errorText = "End date cannot be more than 100 years ago";
          hasError = true;
        } else if (isValidDate(startDate) && startDate.trim(" ").length > 0) {
          if (Moment(startDate) > Moment(event.target.value)) {
            errorText = "End date cannot be before Start date";
            hasError = true;
          }
        }
      }
      await this.setState({
        training_end_date_error: hasError,
        training_end_date_error_text: errorText,
        formHasError: hasError,
      });
      if (this.state?.training_start_date_error && !hasError) {
        const syntheticEvent = {
          target: {
            id: "training_start_date",
            value: this.state.training_start_date,
          },
        };
        await this.onBlur(syntheticEvent);
      }
    } else if (event.target.id === "subsidy") {
      await this.setState({
        subsidy_error: event.target.value.trim(" ").length === 0,
        formHasError: event.target.value.trim(" ").length === 0,
      });
    } else if (event.target.id === "insurance_sales") {
      obj_error = document.getElementById(event.target.id + "_error");

      if (event.target.value.trim(" ").length === 0) {
        obj_error.style.display = "block";
        event.target.style.border = "1px solid #e21224";
        event.target.style.color = "#e21224";
        await this.setState({ formHasError: true });
      } else {
        obj_error.style.display = "none";
        event.target.removeAttribute("style");
      }
    } else if (event.target.id === "total_insurance_sales") {
      obj_error = document.getElementById(event.target.id + "_error");

      if (event.target.value.trim(" ").length === 0) {
        obj_error.style.display = "block";
        event.target.style.border = "1px solid #e21224";
        event.target.style.color = "#e21224";
        await this.setState({ formHasError: true });
      } else {
        obj_error.style.display = "none";
        event.target.removeAttribute("style");
      }
    } else if (event.target.id.startsWith("break_start_date")) {
      let endDate = this.state.break_end_date;
      if (
        event.target.value?.includes("_") ||
        event.target.value?.trim(" ").length === 0 ||
        event.target.value?.slice(-4) === "0000" ||
        !isValidDate(event.target.value)
      ) {
        errorText = "Please enter a Start Date";
        hasError = true;
      } else {
        const [month, day, year] = event.target.value?.split("/") || [];
        const dateCalc = Moment(year + "-" + month + "-" + day);
        const yearDiff = currDate.diff(dateCalc, "year");

        if (dateCalc > currDate) {
          errorText = "Start date cannot be a future date";
          hasError = true;
        } else if (yearDiff >= 100) {
          errorText = "Start date cannot be more than 100 years ago";
          hasError = true;
        } else if (isValidDate(endDate) && endDate.trim(" ").length > 0) {
          if (Moment(event.target.value) > Moment(endDate)) {
            errorText = "Start date cannot be after end date.";
            hasError = true;
          }
        }
      }
      await this.setState({
        break_start_date_error: hasError,
        break_start_date_error_text: errorText,
        formHasError: hasError,
      });

      if (this.state?.break_end_date_error && !hasError) {
        const syntheticEvent = {
          target: {
            id: "break_end_date",
            value: this.state.break_end_date,
          },
        };
        await this.onBlur(syntheticEvent);
      }
    } else if (event.target.id.startsWith("break_end_date")) {
      const startDate = this.state?.break_start_date;
      const endDate = Moment(event.target.value);

      if (
        event.target.value.includes("_") ||
        event.target.value.trim(" ").length === 0 ||
        event.target.value.slice(-4) === "0000" ||
        !isValidDate(event.target.value)
      ) {
        errorText = "Please enter an End Date";
        hasError = true;
      } else if (endDate < tenYearsAgo) {
        errorText = "End dates must fall within the last 10 years";
        hasError = true;
      } else {
        const [month, day, year] = event.target.value?.split("/") || [];
        const dateCalc = Moment(year + "-" + month + "-" + day);
        const yearDiff = currDate.diff(dateCalc, "year");

        if (dateCalc > currDate) {
          errorText = "End date cannot be a future date";
          hasError = true;
        } else if (yearDiff >= 100) {
          errorText = "End date cannot be more than 100 years ago";
          hasError = true;
        } else if (isValidDate(startDate) && startDate.trim(" ").length > 0) {
          if (Moment(startDate) > Moment(event.target.value)) {
            errorText = "End date cannot be before Start date";
            hasError = true;
          }
        }
      }
      await this.setState({
        break_end_date_error: hasError,
        break_end_date_error_text: errorText,
        formHasError: hasError,
      });
      if (this.state?.break_start_date_error && !hasError) {
        const syntheticEvent = {
          target: {
            id: "break_start_date",
            value: this.state.break_start_date,
          },
        };
        await this.onBlur(syntheticEvent);
      }
    } else if (event.target.id === "other_text") {
      await this.setState({
        other_text_error: event.target.value.trim(" ").length < 2,
        formHasError: event.target.value.trim(" ").length < 2,
      });
    } else if (event.target.id === "industry_select") {
      var industryCtrl = document.getElementById("industry_select");
      industryCtrl.style = "none";
      obj_error = document.getElementById("industry_select_error");
      if (
        event.target.id.includes("option") &&
        this.state.ctrl_with_focus.includes("industry_option")
      ) {
        //do nothing
      } else {
        if (this.state.industry_select_id === "") {
          obj_error.style.display = "block";
          industryCtrl.style.border = "1px solid #e21224";
          industryCtrl.color = "#e21224";
          await this.setState({ formHasError: true });
        } else {
          obj_error.style.display = "none";
          industryCtrl.removeAttribute("style");
        }
      }
    }
    await this.validateFields();
  }

  async handlePlaceSelect(addressObject) {
    //this.props.isFormComplete(false);
    //this.props.hasCurrentFormChanged(true);
    await this.setState({ is_validated: false });
    var address_components = this.getAddressComponents(
      addressObject.address_components
    );

    let input;
    if (address_components.street_number === "") {
      input = this.state.street_address.split(" ");

      if (address_components.street === "") {
        for (let i = 0; i < input.length; i++)
          input[i] = input[i][0].toUpperCase() + input[i].substr(1);
        await this.setState({
          street_address: input.join(" "),
        });
      } else {
        await this.setState({
          //street_address: input[0] + " " + address_components.street,
          street_address: address_components.street,
        });
      }
    } else {
      let addr = address_components.street;
      if (addr.toLocaleUpperCase().includes("AVENIDA")) {
        addr = addr.replace("Avenida", "Ave");
      }
      await this.setState({
        street_address: address_components.street_number + " " + addr,
      });
    }
    let geocoder = new google.maps.Geocoder();

    if (address_components.city === "" && address_components.zip_code !== "") {
      geocoder
        .geocode({
          address:
            address_components.zip_code + "," + address_components.country,
        })
        .then((response) => {
          var newAddressComponents = response.results[0]["address_components"];
          for (var i = 0; i < newAddressComponents.length; i++) {
            if (newAddressComponents[i].types.includes("locality") === true) {
              this.setState({ city: newAddressComponents[i]["long_name"] });
            }
          }
        });
    } else if (
      address_components.city !== "" &&
      address_components.zip_code === ""
    ) {
      geocoder
        .geocode({
          address:
            "10" +
            address_components.street +
            "," +
            address_components.city +
            "," +
            address_components.state +
            "," +
            address_components.country,
        })
        .then((response) => {
          let newAddressComponents = response.results[0]["address_components"];
          for (var i = 0; i < newAddressComponents.length; i++) {
            if (
              newAddressComponents[i].types.includes("postal_code") === true
            ) {
              this.setState({ zip_code: newAddressComponents[i]["long_name"] });
            }
          }
        });
    }
    this.clearInputErrors();

    await this.setState({
      city: address_components.city,
      state: address_components.state,
      zip_code: address_components.zip_code,
      address2: "",
      urbanization: "",
      country:
        address_components.country === "Puerto Rico"
          ? "US"
          : address_components.country.match(/\b(\w)/g).join(""),
      show_state_required: this.state.country === "US",
    });

    this.validateFields();
  }
  getAddressComponents(address) {
    var USAddressComponents = {
      street_number: ["street_number"],
      street: ["street_address", "route"],
      city: [
        "locality",
        "sublocality",
        "sublocality_level_1",
        "sublocality_level_2",
        "sublocality_level_3",
        "sublocality_level_4",
      ],
      state: [
        "administrative_area_level_1",
        "administrative_area_level_2",
        "administrative_area_level_3",
        "administrative_area_level_4",
        "administrative_area_level_5",
      ],
      zip_code: ["postal_code"],
    };

    var address_components = {
      street_number: "",
      street: "",
      city: "",
      state: "",
      zip_code: "",
      country: "",
      urbanization: "",
    };

    address.forEach((component) => {
      switch (component.long_name) {
        case "Puerto Rico":
        case "United States":
          address_components.country = component.long_name;

          if (address_components.country === "Puerto Rico")
            this.handleShowUrbanization();
          else this.handleHideUrbanization();

          break;
        default:
      }
    });

    address.forEach((component) => {
      for (var addressComponent in USAddressComponents) {
        if (
          USAddressComponents[addressComponent].indexOf(component.types[0]) !==
          -1
        ) {
          if (addressComponent === "state") {
            if (address_components.country === "Puerto Rico") {
              address_components[addressComponent] = "PR";
            } else {
              address_components[addressComponent] = component.short_name;
            }
          } else {
            address_components[addressComponent] = component.long_name;
          }
        }
      }
    });
    return address_components;
  }
  async handleShowUrbanization() {
    await this.setState({ showUrbanization: true });
  }

  async handleHideUrbanization() {
    await this.setState({ showUrbanization: false });
  }
  async clearInputErrors() {
    await this.setState({
      street_address_error: false,
      city_error: false,
      state_error: false,
      zip_code_error: false,
      country_error: false,
    });
  }
  async handleUseEnteredAddress() {
    await this.setState({
      is_validated: true,
      useSuggestedAddress: false,
    });
    this.state.sales === "Y" && this.state.step_number === 1
      ? this.nextClick()
      : this.addClick();
  }

  renderBtnLabel() {
    if (this.state.currentTab === EMPL_BREAK) {
      return this.state.review_edit ? "SAVE" : "ADD";
    }

    if (this.props.contracttype === CONTRACT_TYPE_DESCRIPTIONS.MMLIS) {
      if (
        (this.state.step_number === 1 && this.state.sales === "N") ||
        (this.state.step_number === 1 && this.state.sales === "")
      ) {
        return this.state.review_edit ? "SAVE" : "ADD";
      }

      if (this.state.step_number === 2 && this.state.sales === "Y") {
        return this.state.review_edit ? "SAVE" : "ADD";
      }
    }

    if (
      (this.state.step_number === 1 && this.state.sales === "N") ||
      (this.state.step_number === 1 && this.state.sales === "")
    ) {
      return this.state.review_edit ? "Next" : "ADD";
    }

    if (this.state.step_number === 2 && this.state.sales === "Y") {
      return this.state.review_edit ? "Next" : "ADD";
    }

    return "Next";
  }

  async handleUseSuggestedAddress() {
    if (this.state.usps_address.toUpperCase().includes("URB")) {
      await this.setState({
        street_address: this.state.usps_address2,
        address2: "",
        city: this.state.usps_city,
        state: this.state.usps_state,
        zip_code: this.state.usps_zip_code,
        country: this.state.country,
        urbanization: this.state.usps_address,
        is_validated: true,
        useSuggestedAddress: true,
      });
    } else {
      await this.setState({
        street_address: this.state.usps_address,
        address2: this.state.usps_address2,
        city: this.state.usps_city,
        state: this.state.usps_state,
        zip_code: this.state.usps_zip_code,
        country: this.state.country,
        urbanization: "",
        is_validated: true,
        useSuggestedAddress: true,
      });
    }
    if (this.state.usps_state === "PR") this.handleShowUrbanization();
    else this.handleHideUrbanization();
    this.state.sales === "Y" && this.state.step_number === 1
      ? this.nextClick()
      : this.addClick();
  }
  async handleCloseModal(x) {
    if (x === "confirm") {
      await this.setState({ form_has_changed: true, psrCheckbox: false });
    }
    if (this.state.form_has_changed && x !== "confirm") {
      await this.setState({ showBackModal: true });
    } else {
      await this.setState({ showBackModal: false });
      if (x !== "confirm") {
        this.cancelClick();
      }
    }
    if (x === "close") {
      await this.setState({ showBackModal: false, showModal: false });
    }
  }

  onFocus = (event) => {
    if (event.target.street_address) {
      event.target.autocomplete = "new-address";
    }
  };
  async handleCloseBackModal() {
    await this.setState({ showBackModal: false });
  }

  async handleBackClick() {
    await this.setState({ form_has_changed: false });
    this.handleCloseBackModal();
    this.resetFields();
    this.props.actionCancel(null);
  }

  async handleIndustryChange(event) {
    await this.setState({
      industry_select_desc: event.target.innerText,
      industry_select_id: event.target.value,
      is_form_saved: false,
      formHasChanged: true,
    });
  }

  render() {
    const { showBackModal, showModal } = this.state;
    const { isOpen } = this.props;

    return (
      <>
        <div>
          <div id="addressModal"></div>

          <div>
            <Modal
              id="empHistModal"
              show={isOpen && !showBackModal && !showModal}
              className="modal-md"
              title=""
            >
              <div id="top_element">
                <div className="modal-body">
                  <div className="container">
                    {this.state.step_number > 0 && (
                      <>
                        <div className="modal-header">
                          <h2>Add Experience</h2>
                          <button
                            id="emp_hist_close_modal"
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close modal dialog"
                            onClick={this.handleCloseModal}
                          />
                        </div>
                        <div className="mm-tabnav">
                          <ul
                            className="nav nav-tabs"
                            id="sampleTab"
                            role="tablist"
                          >
                            {this.state?.showEmploymentExperienceTab && (
                              <li
                                className={`nav-item${!this.state.showEmploymentBreakTab ? " no-margin" : ""}`}
                                role="presentation"
                              >
                                <button
                                  className={
                                    this.state.currentTab ===
                                    "Employment Experience"
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  id="experience"
                                  onClick={this.updateCurrentTab}
                                >
                                  Employment Experience
                                </button>
                              </li>
                            )}
                            {this.state?.showEmploymentBreakTab && (
                              <li
                                className={`nav-item${!this.state.showEmploymentExperienceTab ? " no-margin" : ""}`}
                                role="presentation"
                              >
                                <button
                                  className={
                                    this.state.currentTab === "Employment Break"
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  id="break"
                                  onClick={this.updateCurrentTab}
                                  disabled={this.state.disableEmploymentBreak}
                                >
                                  Employment Break
                                </button>
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="tab-dropdown-wrapper">
                          <Dropdown
                            id="new_dropdown0"
                            type="default"
                            onSelect={(eventKey) =>
                              this.handleTabChange(eventKey)
                            }
                          >
                            <Dropdown.Toggle
                              id="tabtoggle"
                              variant="secondary"
                              aria-label={`${
                                this.state.currentTab
                                  ? this.state.currentTab + ", selected"
                                  : "Select a suffix"
                              }`}
                            >
                              {this.state.currentTab || "\u00A0"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu id="sample_menu0">
                              {this.state?.showEmploymentExperienceTab && (
                                <Dropdown.Item
                                  eventKey={"experience"}
                                  id="experience"
                                >
                                  Employment Experience
                                </Dropdown.Item>
                              )}
                              {this.state?.showEmploymentBreakTab &&
                                !this.state.disableEmploymentBreak && (
                                  <Dropdown.Item eventKey={"break"} id="break">
                                    Employment Break
                                  </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <hr
                          id="emp_hist_modal_hr"
                          style={{ color: "#C1C9D5", marginTop: "-5px" }}
                        />
                      </>
                    )}
                    {this.state.step_number > 0 && (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <span className="required-field-text">
                              * = Required Field
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    {this.state.step_number === 0 && (
                      <div
                        className="row"
                        style={{ marginTop: "15px", height: "350px" }}
                      >
                        <div
                          id="emp_hist_loading"
                          className="mm-dots-loading-xl"
                        />
                      </div>
                    )}
                    {this.state.step_number === 1 && (
                      <StepOne
                        state={this.state}
                        onBlur={this.onBlur}
                        onKeyDown={this.onKeyDown}
                        handleChange={this.handleChange}
                        handleSalesChange={this.handleSalesChange}
                        handleIRBChange={this.handleIRBChange}
                        handleCurrentlyWorkingChange={
                          this.handleCurrentlyWorkingChange
                        }
                        handleContactEmployerChange={
                          this.handleContactEmployerChange
                        }
                        handlePhoneChange={this.handlePhoneChange}
                        handleIndustryChange={this.handleIndustryChange}
                        clickFunc={clickFunc}
                        onFocus={this.onFocus}
                        onFocusState={this.onFocusState}
                        handlePlaceSelect={this.handlePlaceSelect}
                        onCurrentlyWorkingYesClick={
                          this.onCurrentlyWorkingYesClick
                        }
                      />
                    )}
                    {this.state.step_number === 2 && (
                      <StepTwo
                        state={this.state}
                        onBlur={this.onBlur}
                        onKeyDown={this.onKeyDown}
                        handleChange={this.handleChange}
                        handleIndividualLifeChange={
                          this.handleIndividualLifeChange
                        }
                        handleIndividualAnnuityChange={
                          this.handleIndividualAnnuityChange
                        }
                        handleIndividualDisabilityChange={
                          this.handleIndividualDisabilityChange
                        }
                        handleLongTermCareChange={this.handleLongTermCareChange}
                        handleFullTimeRoleChange={this.handleFullTimeRoleChange}
                        handleTrainingChange={this.handleTrainingChange}
                        onlyNumeric={onlyNumeric}
                        pasteCommaDelimited={pasteCommaDelimited}
                        hasNYRegs={this.props.hasNYRegs}
                        addClick={this.addClick}
                        backClick={this.backClick}
                        contracttype={this.props.contracttype}
                        handleNext={this.handleNext}
                      />
                    )}
                    {this.state.step_number === 3 && (
                      <StepThreeEmplHistBreak
                        state={this.state}
                        onBlur={this.onBlur}
                        onKeyDown={this.onKeyDown}
                        handleChange={this.handleChange}
                        handleCurrentlyOnbreak={this.handleCurrentlyOnbreak}
                      />
                    )}
                    {this.state.step_number === 4 &&
                      this.props.contracttype !==
                        CONTRACT_TYPE_DESCRIPTIONS.MMLIS && (
                        <StepFourPSRConfirmation
                          oktaSubId={this.props.subId}
                          state={this.state}
                          psrPreviewData={this.state.psrPreviewData}
                          handlePsrCheckboxChange={this.handlePsrCheckboxChange}
                          hasNYRegs={this.props.hasNYRegs}
                        />
                      )}
                    {/* ADD BUTTON PANEL START */}
                    {this.state.show_add_button &&
                      this.state.step_number !== 2 &&
                      this.state.step_number > 0 &&
                      this.state.step_number !== 4 && (
                        <NavigationButtons
                          nxtbtnid={"empHistNextBtn"}
                          nextBtnText={this.renderBtnLabel()}
                          onNext={this.handleNext}
                          bckbtnid={"empHistBackBtn"}
                          backBtnText="Cancel"
                          onBack={this.handleCloseModal}
                          isDisabled={
                            this.state.is_add_disabled ||
                            this.state.showSaveLoader
                          }
                          isLoading={this.state.showSaveLoader}
                        ></NavigationButtons>
                      )}
                    {this.state.step_number === 4 && (
                      <NavigationButtons
                        nxtbtnid={"empHistNextBtn"}
                        nextBtnText={"Save"}
                        onNext={this.handleNext}
                        bckbtnid={"empHistBackBtn"}
                        backBtnText="Back"
                        onBack={this.backClickPSR}
                        isDisabled={
                          this.state.is_add_disabled ||
                          (!this.state.psrCheckbox &&
                            this.state.form_has_changed) ||
                          this.state.showSaveLoader ||
                          !this.state.form_has_changed
                        }
                        isLoading={this.state.showSaveLoader}
                      ></NavigationButtons>
                    )}

                    {/* ADD BUTTON PANEL END */}
                    {/* NEXT BUTTON PANEL START */}
                    {this.state.show_next_button &&
                      (this.state.step_number > 0 ||
                        this.state.step_number === 2) && (
                        <NavigationButtons
                          nxtbtnid={"empHistNextBtn"}
                          nextBtnText={this.renderBtnLabel()}
                          onNext={this.handleNext}
                          bckbtnid={"empHistBackBtn"}
                          backBtnText="Cancel"
                          onBack={this.handleCloseModal}
                          isDisabled={
                            this.state.is_next_disabled ||
                            this.state.showSaveLoader
                          }
                          isLoading={this.state.showSaveLoader}
                        ></NavigationButtons>
                      )}
                    {/* NEXT BUTTON PANEL END */}
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>

        <USPSValidationModal
          isOpen={this.state.showModal}
          closeModal={this.handleCloseModal}
          useSuggestedAddress={this.handleUseSuggestedAddress}
          useEnteredAddress={this.handleUseEnteredAddress}
          street_address={this.state.street_address}
          address2={this.state.address2}
          city={this.state.city}
          state={this.state.state}
          zip_code={this.state.zip_code}
          country={this.state.country}
          usps_address={this.state.usps_address}
          usps_address2={this.state.usps_address2}
          usps_city={this.state.usps_city}
          usps_state={this.state.usps_state}
          usps_zip_code={this.state.usps_zip_code}
          usps_country={this.state.usps_country}
          urbanization={this.state.urbanization}
          addressNotFound={this.state.addressNotFound}
          contracttypedesc={this.props.contracttypedesc}
          src_id={this.state.form_id}
          formHasChanged={this.state.form_has_changed}
          exitModal={this.handleBackClick}
        />
        <LostDataModal
          isOpen={this.state.showBackModal && !this.state.showModal}
          handleClose={this.handleCloseBackModal}
          handleProceed={this.handleBackClick}
        />
      </>
    );
  }
}

export default EmploymentHistoryModal;
